<template>
  <ve-histogram
    :data="$attrs.histogramData"
    :settings="$attrs.histogramSettings"
    :legend-visible="$attrs.legendVisible || false"
    :height="$attrs.height"
    :colors="$attrs.colors"
    :extend="$attrs.chartOptions"
    :data-empty="$attrs.dataEmpty"
    :data-zoom="$attrs.dataZoom"
    :resizeable="$attrs.resizeable"
  />
</template>
<script>
import veHistogram from 'v-charts/lib/histogram.common'
import 'echarts/lib/component/dataZoom'

export default {
  name: 'histogram',
  inheritAttrs: false,
  data() {
    return {}
  },
  components: {
    veHistogram
  }
}
</script>
